import { useState } from "react";
import { api } from "../../services/apiService";

export default function useEventosLog() {
  const [eventosLog, setEventosLog] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [todosUsuarios, setTodosUsuarios] = useState([]);

  const listarEventosLog = async (page = 1, pageSize = 20, filtroData = "", filtroUsuario = "") => {
    try {
      const response = await api.eventosLog.getAll(page, pageSize, filtroData, filtroUsuario);
      const data = response.data;
      
      setTotalCount(data.totalCount || 0);
      
      setEventosLog(
        data.items.map(e => ({
          id: e.id,
          email: e.usuarioEmail,
          acao: e.acao,
          dataHora: new Date(e.dataOcorrencia.endsWith('Z') ? e.dataOcorrencia : e.dataOcorrencia + 'Z').toLocaleString('pt-BR', {
            timeZone: 'America/Sao_Paulo',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          })
        }))
      );
    } catch (error) {
      alert(error.response.data.message);
    }
  }

  const buscarTodosUsuarios = async () => {
    try {
      const response = await api.usuario.getEmails();
      const emails = response?.data || response || [];
      setTodosUsuarios(emails);
    } catch (error) {
      setTodosUsuarios([]);
    }
  }

  return { eventosLog, totalCount, todosUsuarios, listarEventosLog, buscarTodosUsuarios };
}